module.exports = __webpack_public_path__ + "img/report-2.c6bfc9bf.jpg";